export default "__VITE_ASSET__DOmss5ak__"